/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ContentStudioStage1RequestResources } from './contentStudioStage1RequestResources';
import type { ContentStudioStage1RequestConfig } from './contentStudioStage1RequestConfig';

/**
 * Initial input: Topic and optional resources.
 */
export interface ContentStudioStage1Request {
  /** The main topic or instruction from the lecturer */
  prompt: string;
  /** Optional list of URLs or text content to ground the research */
  resources?: ContentStudioStage1RequestResources;
  config?: ContentStudioStage1RequestConfig;
}
